// let counterElement = document.querySelector('#cart-quantity');
// if(counterElement)
//   counterElement.style.display = 'none';

// update flyout-header count inside cart popup
const flyoutPopupCounter = (cartItemsCount) => {
  let flyoutCounterElements = Array.from(document.querySelectorAll('.rebuy-cart__flyout-header .items-count'));
  flyoutCounterElements.forEach(flyoutCounterElement => {
    if (flyoutCounterElement && cartItemsCount > -1) {
      flyoutCounterElement.innerText = `${cartItemsCount} item${cartItemsCount === 1 ? '' : 's'}`;
    }
  });
};


const updateCartCounter = (event) => {

  let cartCount = 0;
  if (event.type === 'rebuy:cart.change') {
    cartCount = event.detail.cart.cart.item_count;
  } else {
    if (event.detail.smartcart) {
      cartCount = event.detail.smartcart.cart.item_count;
    }
  }

  let smartCartObject = window.Rebuy.SmartCart || event.detail.smartcart;
  let tieredProducts = (smartCartObject
    && smartCartObject.progressBar
    && smartCartObject.progressBar.earnedProducts)
    || [];
  let tieredProductsVariantIds = [];
  tieredProducts.forEach(x => {
    x.variants.forEach(y => tieredProductsVariantIds.push(y.id));
  })
  let requiredProducts = smartCartObject.cart.items.filter(x => !tieredProductsVariantIds.some(y => x.variant_id === y));
  let requiredProductCount = requiredProducts.map(x => x.quantity).reduce((acc,curr) => {
    acc = acc + curr;
    return acc;
  },0);

  
  let cartItemsCount = 0;
  if(requiredProductCount > -1){
    cartItemsCount = requiredProductCount;
  }
  const cartCountElement = document.querySelector('#cart-quantity .cart-option--quantity');
  if (cartCountElement && cartItemsCount > -1) {
    // update bag icon counter
    cartCountElement.innerText = cartItemsCount;
    if (event.type === 'rebuy:smartcart.ready') {
      cartCountElement.style.display = 'block';
      setTimeout(() => { flyoutPopupCounter(cartItemsCount) }, 1000);
    }

    flyoutPopupCounter(cartItemsCount);


  }
  setTimeout(() => {

  }, 1000)
}

const checkForSampleProductsAndHideQuantityWidget = () => {
  setTimeout(() => {
    // check for product with sample tags
    if (Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.cart && Rebuy.SmartCart.cart.items.length) {
      let cartItems = Rebuy.SmartCart.cart.items;
      for (let item of cartItems) {
        let productTags = item.product && item.product.tags ? item.product.tags.split(',').map(x => x.trim().toLowerCase()) : [];
        if (productTags.indexOf('sample') > -1) {
          // find the cart item in flyout
          let selector = `.rebuy-cart__flyout-item.product-${item.product.handle} .rebuy-cart__flyout-item-quantity-widget-button`;
          let els = Array.from(document.querySelectorAll(selector));
          if (els && els.length) {
            els.forEach(el => {
              el.style.display = 'none';
            })
          }

        } else {
          let selector = `.rebuy-cart__flyout-item.product-${item.product.handle} .rebuy-cart__flyout-item-quantity-widget-button`;
          let els = Array.from(document.querySelectorAll(selector));
          if (els && els.length) {
            els.forEach(el => {
              el.style.display = 'block';
            })
          }
        }
      }
    }
  }, 1000)
}

const checkForBundlesAndHideQuantityWidget = () => {
  setTimeout(function () {
    let cartElements = Array.from(document.querySelectorAll('.rebuy-cart__flyout-item'));
    cartElements.forEach(el => {
      let cls = el.getAttribute('class');
      if (cls.indexOf('property-value-rebuy-dynamic-product-bundle') > -1) {
        let qtyWidgetButtons = Array.from(el.querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button'));
        if (qtyWidgetButtons && qtyWidgetButtons.length) {
          qtyWidgetButtons.forEach(b => { b.style.display = 'none' })
        }
      }
    })


  }, 100);
}

document.addEventListener('rebuy:smartcart.ready', (event) => {
  setTimeout(() => {
    updateCartCounter(event);
    checkForBundlesAndHideQuantityWidget();
  }, 500)
});

document.addEventListener("rebuy:cart.change", (event) => {
  setTimeout(() => {
    updateCartCounter(event);
    checkForBundlesAndHideQuantityWidget();
    checkForSampleProductsAndHideQuantityWidget();
  }, 1000)
});

document.addEventListener('rebuy:smartcart.product-removed', (event) => {
  setTimeout(() => {
    updateCartCounter(event);
    checkForBundlesAndHideQuantityWidget();
    checkForSampleProductsAndHideQuantityWidget();
  }, 1000)
});

// fix overlay
document.addEventListener('rebuy:smartcart.hide', (event) => {
  let overlayElement = document.querySelector('.screen-overlay.show');
  if (overlayElement) {
    overlayElement.classList.remove('show');
    document.body.classList.remove('offcanvas-active');
  }
});



// added on 25th april
const getDiv = (selector) => document.querySelector(selector);

const breakFlyoutCartFooter = () => {

  // Get the wrapper-div element
  const wrapperDiv = document.querySelector(".rebuy-cart__flyout");

  // Create a new div element to hold the last two child elements
  const newDiv = document.createElement("div");

  let childrenDivs = [
    getDiv('.rebuy-cart__flyout-subtotal'),
    getDiv('[data-app-target="below_subtotal"]'),
    getDiv('#smart-cart-terms'),
    getDiv('.rebuy-cart__flyout-installments'),
    getDiv('.rebuy-cart__flyout-actions'),
  ]
  // Move the second and third child elements to the new div
  for (let child of childrenDivs) {
    if (child) {
      newDiv.appendChild(child)
    }
  }
  newDiv.id = 'wrapper-subtotal';

  // Add the new div as the second child element of the wrapper-div
  wrapperDiv.insertBefore(newDiv, wrapperDiv.children[6]);
};
const addHeaderItemsCount = () => {
  // let counterHtml = `<div class="items-count" aria-label="cart item count"></div>`;
  const newDiv = document.createElement("div");
  newDiv.classList.add("items-count");
  newDiv.setAttribute('aria-label', 'cart item count');
  let cartHeaderElement = getDiv('.rebuy-cart__flyout-header');
  if (cartHeaderElement && newDiv) {
    cartHeaderElement.appendChild(newDiv);
  }


}


document.addEventListener('rebuy:cart.ready', (event) => {
  setTimeout(() => {
    // for desktop
    // 
   // breakFlyoutCartFooter();
    addHeaderItemsCount();
    checkForSampleProductsAndHideQuantityWidget();
  }, 1000);

});

// show subtotal wrappen even when no items in cart. // fix for safari issue
// document.addEventListener('rebuy:smartcart.show', (event) => {
//   let isSafari = window.navigator && window.navigator.vendor && window.navigator.vendor.toLowerCase().indexOf("apple") > -1;
//   if(isSafari){
//     console.log('safari');
//     let subtotal = document.querySelector('#wrapper-subtotal');
//     if(subtotal){
//       subtotal.style.display = 'none';
//       setTimeout(() => {
//         subtotal.style.display = 'block';
//       },10)
//     }
//   }
  
// });
